import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import RCE5ParameterAdapter from './rce5ParameterAdapter';
import { testable } from '@instructure/ui-testable';
export var RCE_SINGLE_LINE_HEIGHT = 160;
export var RCE_THREE_LINES_HEIGHT = 200;
export var RichContentInput = (_dec = testable(), _dec(_class = /*#__PURE__*/function (_Component) {
  function RichContentInput() {
    var _this2;
    _classCallCheck(this, RichContentInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, RichContentInput, [].concat(args));
    /* istanbul ignore next */
    _defineProperty(_this2, "focus", function () {});
    /* istanbul ignore next */
    _defineProperty(_this2, "handleRef", function (node) {
      return _this2.rce = node;
    });
    _defineProperty(_this2, "render", function () {
      return /*#__PURE__*/React.createElement(RCE5ParameterAdapter, Object.assign({
        ref: _this2.handleRef
      }, _this2.props));
    });
    return _this2;
  }
  _inherits(RichContentInput, _Component);
  return _createClass(RichContentInput, [{
    key: "id",
    get: function get() {
      return this.rce.id;
    }
  }]);
}(Component)) || _class);